"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../utilities/colors");
function ConnectedDots(_ref) {
  let {
    dots = [],
    lineColor = colors_1.COLOR_PALETTE['usa-gray'],
    lineWidth = 1,
    onMouseOver = () => {},
    onMouseOut = () => {},
    onClick = () => {}
  } = _ref;
  const dotsList = [];
  const linesList = [];
  dots.forEach((dot, i) => {
    dotsList.push({
      key: dot.key || i,
      color: dot.color || (i === 0 ? colors_1.COLOR_PALETTE['usa-magenta'] : colors_1.COLOR_PALETTE['usa-gray']),
      opacity: dot.opacity !== undefined ? dot.opacity : 1,
      radius: dot.radius || 6.5,
      strokeColor: dot.strokeColor || 'transparent',
      strokeWidth: dot.strokeWidth || 0,
      x: dot.x,
      y: dot.y,
      forceRedraw: lodash_1.default.uniqueId()
    });
    if (i > 0) {
      linesList.push({
        key: `line-${dot.key || i}`,
        x1: dots[i - 1].x,
        y1: dots[i - 1].y,
        x2: dots[i].x,
        y2: dots[i].y,
        opacity: dots[i].opacity || 1,
        color: lineColor,
        width: lineWidth,
        forceRedraw: lodash_1.default.uniqueId()
      });
    }
  });
  return react_1.default.createElement("g", null, linesList.map((item, i) => {
    const {
      x1,
      y1,
      x2,
      y2,
      color,
      width,
      opacity,
      key
    } = item;
    return react_1.default.createElement("line", {
      key: `line-${key || i}`,
      x1: x1,
      y1: y1,
      x2: x2,
      y2: y2,
      stroke: color,
      strokeWidth: width,
      style: {
        opacity
      }
    });
  }), dotsList.map((item, i) => {
    const {
      x,
      y,
      radius,
      color,
      strokeColor,
      strokeWidth,
      opacity,
      key
    } = item;
    return react_1.default.createElement("circle", {
      key: `dot-${key || i}`,
      onMouseOver: e => onMouseOver(e, i, item),
      onMouseOut: e => onMouseOut(e, i, item),
      onClick: e => onClick(e, i, item),
      cx: x,
      cy: y,
      r: radius,
      fill: color,
      stroke: strokeColor,
      strokeWidth: strokeWidth,
      style: {
        opacity
      }
    });
  }));
}
ConnectedDots.propTypes = {
  /**
   * Array of dot objects. Each object has the following properties
   * - color, radius:number, strokeColor:color, strokeWidth:number,
   * x:number and y:number. color - is the fill color of the dot,
   * radius represents radius of the dot,
   * strokeColor is color of the border and strokeWidth is the thickness of the border.
   */
  dots: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    key: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
    color: prop_types_1.string,
    opacity: prop_types_1.number,
    radius: prop_types_1.number,
    strokeColor: prop_types_1.string,
    strokeWidth: prop_types_1.number,
    x: prop_types_1.number.isRequired,
    y: prop_types_1.number.isRequired
  })),
  /**
   * thickness of the connecting lines
   */
  lineWidth: prop_types_1.number,
  /**
   * Color of the connecting lines
   */
  lineColor: prop_types_1.string,
  /**
   * function to activate on click
   * parameters: (event, index, item)
   */
  onClick: prop_types_1.func,
  /**
   * function to activate on mouseOver
   * parameters: (event, index, item)
   */
  onMouseOver: prop_types_1.func,
  /**
   * function to activate on mouseOut
   * parameters: (event, index, item)
   */
  onMouseOut: prop_types_1.func
};
exports.default = ConnectedDots;